import React from 'react';
import axios from "axios";
import { connect } from 'react-redux';
import { editarNumeroPatronal, guardarNumeroPatronal } from '../../components/numeroPatronal/NumeroPatronalService';
import { URL, getAuthorizationHeader } from '../../constans/constants';
import safeRedirectManager from '../seguridad/SafeRedirectComponent';
import BreadCrumComponent from "../componentes/BreadCrumComponent";

class VistaPDF extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fechaCarga: "",
      empleado: "",
      estado: "",
      estadoMTESS: false,
      redirect: "",
      comentario: null,
      pdfBase64: null,
      pdfArrayBuffer: null,
      loading: true,
      error: null,
      recibo: null
    }
  }

  componentWillUnmount() {
    const viewerFrame = document.getElementById('pdf-js-viewer');
    if (viewerFrame && viewerFrame.contentWindow) {
      viewerFrame.contentWindow.document.removeEventListener('click', this.handlePDFClick);
      viewerFrame.contentWindow.document.removeEventListener('contextmenu', this.handlePDFRightClick);
    }
    localStorage.removeItem("conceptoONombre");
  }

  setPantallaAnterior = () => {
    return (localStorage.getItem("urlAnterior")).substring(localStorage.getItem("urlAnterior").indexOf("#") + 1)
  }

  initializePDFViewer = () => {
    return new Promise((resolve) => {
      const viewerFrame = document.getElementById('pdf-js-viewer');
      if (!viewerFrame) return resolve();
      viewerFrame.addEventListener('load', () => {
        const viewerWindow = viewerFrame.contentWindow;
        if (!viewerWindow?.PDFViewerApplication) return resolve();
        viewerWindow.PDFViewerApplication.initializedPromise.then(() => {
          this._viewerWindow = viewerWindow;
          viewerWindow.document.addEventListener('click', this.handlePDFClick);
          viewerWindow.document.addEventListener('contextmenu', this.handlePDFRightClick);
          resolve();
        });
      }, { once: true });
    });
  };

  fetchPDF = async () => {
    try {
      const requestUrl = `${URL}recibo/lote/${this.props.match.params.lote}/recibo/${this.props.match.params.recibo}`;
      const response = await axios.get(requestUrl, {
        ...getAuthorizationHeader(),
        responseType: 'arraybuffer'
      });

      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      );

      this.setState({ pdfBase64: base64, loading: false });

      if (this._viewerWindow) {
        await this._viewerWindow.PDFViewerApplication.open({
          data: new Uint8Array(response.data)
        });
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      this.setState({ error: 'Error al cargar el PDF', loading: false });
    }
  }

  setNombreDocumento = () => {
    
    const descripcionLote = this.props.location?.state?.descripcionLote ?? null;

    if (descripcionLote == null)
      return localStorage.getItem("conceptoONombre")
    else {
      localStorage.setItem("conceptoONombre", descripcionLote)
      return descripcionLote
    }
  }

  handlePDFClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
      // Aquí puedes manejar el enlace clickeado como desees
      safeRedirectManager.safeRedirect(target.href);
    }
  }

  handlePDFRightClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
    }
  }

  componentDidMount() {
    this.setPantallaAnterior();
    this.initializePDFViewer().then(() => this.fetchPDF());

    const urlComment = `${URL}lote/${this.props.match.params.lote}/recibo/${this.props.match.params.recibo}/comment`;

    axios
      .get(urlComment, getAuthorizationHeader())
      .then(res => {
        if (!res.data.errors)
          this.setState({ comentario: res.data.datos })
      })
  }

  descargarRecibo = () => {
    if (this.state.pdfBase64) {
      const linkSource = `data:application/pdf;base64,${this.state.pdfBase64}`;
      const downloadLink = document.createElement("a");
      const fileName = `recibo_${this.props.match.params.recibo}.pdf`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }

  handlePaginaAnterior = () => {
    const { pantallaAnterior } = this.state;

    if (pantallaAnterior) {
      this.props.history.push(pantallaAnterior);
    } else {
      this.props.history.goBack();
    }
  }

  render() {

     const descripcionLote = this.setNombreDocumento()

    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={this.setPantallaAnterior()}
              breadcrumbs={
                [
                  { label: 'Lotes', path: this.setPantallaAnterior() },
                  { label: 'Visor de documento', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> Documento nro. {this.props.match.params.recibo} </h1>
                <p className="page-description"> {descripcionLote} </p>
              </div>
              <div className="head-actions">
                <button className="btn-medium btn-base-outline"
                  onClick={this.descargarRecibo}><span className="material-symbols-outlined">download</span>Descargar</button>
              </div>
            </div>

          </div>
        </header>
        <div className="wrapperContent">
          <div className="component-documento">
            <div className="page-container container-sm">
              {
                this.state.comentario != null &&
                <div className="card">
                  <div className="caption-area">
                    <h5> Comentario </h5>
                    <p className="page-description"> {this.state.comentario} </p>
                  </div>
                </div>
              }


              <div className="card">

                <div id="container-file">
                  {this.state.loading && <div>Cargando PDF...</div>}
                  {this.state.error && <div>{this.state.error}</div>}
                  <iframe
                    id="pdf-js-viewer"
                    src={`${window.location.origin}/mirecibo/visor/viewer.html?file=`}
                    title="webviewer"
                    frameBorder="0"
                    width="100%"
                    height="1000px"
                    style={{ display: this.state.loading || this.state.error ? 'none' : 'block' }}
                  ></iframe>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  guardarNumeroPatronal: value => dispatch(guardarNumeroPatronal(value)),
  editarNumeroPatronal: value => dispatch(editarNumeroPatronal(value))
});

export default connect(null, mapDispatchToProps)(VistaPDF);